import {
    deleteRequest,
    putRequest,
    getRequest,
    postRequest,
 } from "../../utils/api";
 
 export const apiListStations = (data) => {
    return postRequest('/api/charge-station/list?page=1&size=20', data)
 }
 
 export const apiUpdate = (data) => {
    return putRequest('/api/charge-station/update', data)
 }
 
 export const apiDelete = (data) => {
    return deleteRequest('/api/charge-station/delete'+id, data)
 }
 export const apiGet = (id) => {
    return getRequest('/api/charge-station/get/'+id)
 }
 export const apiGetArea = (id) => {
    return getRequest('/api/charge-station/listArea')
 }
 export const apiTree = (data) => {
   return postRequest('/api/charge-gateway/tree',data)
}

export const apiCount = (stationId) => {
   return getRequest('/api/charge-gateway/count/'+stationId)
}
export const apiUpdateGateway = (data) => {
   return putRequest('/api/charge-gateway/update', data)
}
 

export const apiUpdateEquipment = (data) => {
   return putRequest('/update', data)
}

export const apiListPrivacy = (data) => {
   return postRequest('/api/price-privacy/list', data)
}

export const apiListCardPrivacy = (data) => {
   return postRequest('/api/card-privacy/list', data)
}

export const apiListGatewayByStation = (data) => {
   return postRequest('/api/charge-gateway/list?page=1&size=20', data)
}

export const apiListEquipmentByStationId = (data) => {
   return postRequest('/api/chargeEquipment/list?page=1&size=20', data)
}



export const apiGetPrivacy = (id) => {
   return postRequest('/api/price-privacy/get/'+ data)
}

export const apiGetCardPrivacy = (data) => {
   return postRequest('/api/card-privacy/get/'+data)
}


 